import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "@citrine/atoms/button";
import {
  CandidatesIcon,
  MaterialIcon,
  PredictorIcon,
  SearchSpaceIcon,
} from "@citrine/atoms/icons";

import * as sx from "./activity-type-card.sx";

export interface ActivityTypeCardProps {
  variant: sx.AlertProps["palette"];
  to?: string;
  children?: ReactNode;
  className?: string;
  "data-testid"?: string;
}
export function ActivityTypeCard({
  variant,
  to,
  children,
  className,
  ["data-testid"]: testId,
}: ActivityTypeCardProps) {
  return (
    <sx.Alert
      data-testid={testId}
      className={className}
      icon={<ActivityTypeIcon variant={variant} />}
      severity={variant === "warning" ? "warning" : undefined}
      palette={variant}
      action={
        variant !== "warning" ? (
          <Button href={to} variant="text" size="small">
            <FormattedMessage id="View" />
          </Button>
        ) : null
      }
    >
      {children}
    </sx.Alert>
  );
}

function ActivityTypeIcon({
  variant,
}: {
  variant: ActivityTypeCardProps["variant"];
}) {
  switch (variant) {
    case "data":
      return <MaterialIcon />;
    case "candidate":
      return <CandidatesIcon />;
    case "predictor":
      return <PredictorIcon />;
    case "search-space":
      return <SearchSpaceIcon />;
    case "warning":
      return <ReportProblemOutlined />;
  }
}
